export default __webpack_public_path__ + "static/media/img.5ab64210.png";